import { useEffect, useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import SearchBarV2 from '../../components/PageHelpers/SearchBarV2.jsx'
import SortByList from '../../components/PageHelpers/Sort.jsx'
import SummariesBtn from '../../components/PageHelpers/SummariesBtn.jsx'
import LoadMoreBtn from '../../components/PageHelpers/LoadMoreBtn.jsx'
import {
  retrieveCompanies,
  companiesResetAlertHandler,
} from '../../redux/features/companies/companiesThunk'
import { selectCompanies } from '../../redux/features/companies/companiesSlice'
import CompanyCard from './CompanyCard.jsx'
import CompanyCardSkeleton from './CompanyCardSkeleton.jsx'
import ConfirmationModalContainer from '../../components/Modals/ConfirmationModalContainer.jsx'
import FinishModalContainer from '../../components/Modals/FinishModalContainer.jsx'
import LoaderWithErrorHandler from '../../components/PageHelpers/LoaderWithErrorHandler.jsx'
import UseTranslation from '../../hooks/UseTranslation.jsx'
import CookiesStorageService from '../../services/CookiesStorageService'
import AppRoutes from '../../services/AppRoutes'
import TitleWithCountV2 from '../../components/PageHelpers/TitleWithCountV2.jsx'
import CompaniesList from '../../images/companies.svg'

const Index = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const companies = useSelector(selectCompanies)
  const { t } = UseTranslation()
  const username = CookiesStorageService.getUserName()
  const [confirmationModalState, setConfirmationModalState] = useState(false)
  const [finishModalState, setFinishModalState] = useState(false)
  const [confirmationData, setConfirmationData] = useState(null)

  useEffect(() => {
    dispatch(retrieveCompanies({ resetQueries: true }))
  }, [dispatch])

  const handleStatusChangeClick = (item, data) => {
    setConfirmationData({
      ...item,
      company: data?.company,
    })
    setConfirmationModalState(true)
  }

  const finishHandler = () => {
    dispatch(retrieveCompanies({ resetQueries: true }))
    setFinishModalState(false)
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.titleBox}>
       <Typography sx={styles.welcomeHeader}>{t?.Welcome}, {username ?? `${t?.User}`}</Typography>
        <SearchBarV2
          actionToDispatch={retrieveCompanies}
          searchPlaceholder={t?.['Search by Company or Tenant']}
          customStyles={styles.searchBarContainer}
          sendQueryAsObject
          actionProps={{ pageNumber: 0 }}
        />
      </Box>
      <Box sx={styles.body}>
        <Box sx={styles.optionsBox}>
          <SummariesBtn actionToDispatch={retrieveCompanies} store={companies} sendQueryAsObject
          />
          <Box sx={styles.sortAddBox}>
            <SortByList actionToDispatch={retrieveCompanies} store={companies} sendQueryAsObject
            actionProps={{ pageNumber: 0 }}
            />
            <Button
              onClick={() => history.push(AppRoutes.addCompany)}
              sx={styles.modalBtn}
            >
              {t?.['Add Company']}
            </Button>

          </Box>
        </Box>
          <TitleWithCountV2
          icon={<img src={CompaniesList} alt="CompaniesList" />}
          iconSize='xl'
          store={companies}
          title={t?.['All Companies']}
          customCount={t?.Companies}
          withCount
          customStyle={styles.titleHeader}
        />
        {companies?.data?.length > 0 &&
          companies?.data?.map((company) => company?.tenant_list?.map((tenant) => (
              <CompanyCard
                key={`${company.id}-${tenant.id}`}
                data={{ company, tenant, integration: tenant.integration }}
                onStatusChangeClick={handleStatusChangeClick}
              />
          )))}
        <LoaderWithErrorHandler
          store={companies}
          resetAlertHandler={companiesResetAlertHandler}
          Skeleton={CompanyCardSkeleton}
        />
        <LoadMoreBtn actionToDispatch={retrieveCompanies} store={companies} sendQueryAsObject />
      </Box>

      <ConfirmationModalContainer
        modalState={confirmationModalState}
        setModalState={setConfirmationModalState}
        setFinishModalState={setFinishModalState}
        confirmationData={confirmationData}
        confirmHandler={confirmationData?.confirmHandler}
        confirmHandlerQueries={{
          title: confirmationData?.title,
          data: confirmationData?.company,
        }}
      />
      <FinishModalContainer
        modalState={finishModalState}
        modalChangeState={setFinishModalState}
        modalTitle={confirmationData?.title}
        modalMessage={confirmationData?.finish}
        finishHandler={finishHandler}
      />
    </Box>
  )
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: { xs: 'auto', sm: 'unset' },
    padding: { xs: 'auto', sm: '0 15px' },
  },
  titleBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: '95%',
    gap: { xs: '5px', sm: '0px' },
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    alignItems: { xs: 'flex-start', sm: 'normal' },
    margin: { xs: '0 0 10px 0', sm: 'unset' },
    svg: {
      fontSize: { xs: '20px', sm: 'unset' },
      marginTop: { xs: '10px', sm: 'unset' },
    },
  },
  welcomeHeader: {
    fontSize: { xs: '16px', sm: '24px' },
  },
  optionsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'normal', md: 'center' },
    marginTop: '2%',
  },
  sortAddBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: { xs: 'space-between', md: 'normal' },
    paddingTop: { xs: '10px', sm: 'unset' },
  },
  titleContainer: {
    paddingTop: { xs: '10px', sm: 'unset' },

  },
  body: {
    width: { xs: '95%', lg: '95%' },
  },
  searchBarContainer: {
    width: { xs: '100%', sm: '550px' },
    height: '40px',
  },
  modalBtn: {
    textTransform: 'capitalize',
    fontSize: { xs: '10px', md: '14px' },
    color: 'white',
    backgroundColor: '#29CC8B',
    width: { xs: '25vw', md: '100%' },
    minWidth: { xs: '100px', md: '130px' },
    minHeight: { xs: '30px', md: '40px' },
    borderRadius: '10px',
    '&:hover': {
      color: 'white',
      backgroundColor: '#29CC8B',
    },
  },
  titleHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '10px',
    marginBottom: '10px !important',
    gap: { xs: '5px', sm: '10px' },
    '& img': {
      paddingRight: '5px',
      width: '30px',
      height: '30px',
      marginBottom: { xs: '0px', sm: '10px' },
    },
    '& span': {
      fontFamily: 'Avenir 85 light',
      fontWeight: 400,
      fontSize: { xs: '16px', sm: '24px' },
      lineHeight: { xs: '20.15px', sm: '37.08px' },
    },
    '& p': {
      margin: '0',
    },
  },
}

export default Index
